import React from 'react';
import { ProfileSwitcher } from '@components/profile-switcher';
import routes from '@config/routes';
import { useOnboardingControls } from '@features/onboarding';
import { useToggle } from '@goodfynd/hooks';
import { ColorSchemeToggle } from '@goodfynd/layout';
import { useScreenXLarge } from '@goodfynd/theme';
import { Divider, IconButton } from '@goodfynd/ui';
import { FlexView } from '@goodfynd/ui';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import classnames from 'clsx';

import { DashboardUserProfile } from '../DashboardUserProfile';
import { Navigation } from '../Navigation';

import classes from './DashboardHeader.module.css';

export function DashboardHeader({
  children,
  drawerContent,
  isOrganization,
  navigation,
  profileSwitcher,
  rightNode,
}: DashboardHeaderProps) {
  const isDesktop = useScreenXLarge();
  const [open, toggle] = useToggle();
  const { openOnboarding } = useOnboardingControls();

  return (
    <>
      <FlexView
        align="center"
        className={classnames(classes.header)}
        justify="space-between"
        tag="header"
        wrap="nowrap"
      >
        <div className={classes['header-left-container']}>
          <div className={classes['header-switcher']}>
            {profileSwitcher ?? (
              <ProfileSwitcher isOrganization={isOrganization} />
            )}
          </div>

          {children}
        </div>

        <div className={classes['header-right']}>
          {rightNode}

          <IconButton
            icon="info"
            iconSize={24}
            onClick={openOnboarding}
            size="small"
            tooltip={{ title: 'Onboarding guide' }}
          />

          <IconButton
            href={routes.docs}
            icon="help"
            iconSize={24}
            size="small"
            tooltip={{ title: 'Help' }}
          />

          {isDesktop ? (
            <DashboardUserProfile />
          ) : (
            <IconButton
              className={classes['drawer-button']}
              icon="more"
              iconSize={24}
              onClick={toggle}
              size="small"
            />
          )}
        </div>
      </FlexView>

      <SwipeableDrawer
        anchor="right"
        onClose={() => toggle(false)}
        onOpen={() => toggle(true)}
        open={open}
      >
        {drawerContent}

        <div className={classes['drawer-container']}>
          <div className={classes['drawer-profile']}>
            <DashboardUserProfile />
          </div>

          <Divider />

          <div className={classes['nav-switcher']}>
            {profileSwitcher ?? (
              <ProfileSwitcher isOrganization={isOrganization} />
            )}
          </div>

          <Divider />

          <div className={classes['drawer-nav']}>
            {navigation ?? <Navigation />}
          </div>

          <Divider />

          <FlexView justify="center" padding="XLarge">
            <ColorSchemeToggle />
          </FlexView>
        </div>
      </SwipeableDrawer>
    </>
  );
}
